/**
 *
 * Feel free to COPY and ADAPT this class if you need to target a set of element seperately
 */

// Import NPM library
// require('waypoints/lib/noframework.waypoints');
// import inView from 'in-view'
const inView = require('in-view')

export default class ScrollAnimation {
  constructor(context) {
    // context.querySelectorAll('[data-animation]').forEach(el => this.setElement(el));
    inView('[data-animation]')
      .on('enter', el => el.classList.add('is-visible'))
      .on('exit', el => el.classList.remove('is-visible'))
  }

  // setElement(element) {
  //   new Waypoint({
  //     element,
  //     handler(direction) {
  //       this.element.classList.add('is-visible');
  //     },
  //     offset: '98%'
  //   });

  // }
}
